var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useStateWithMutators } from '@rad/hooks';
import { useAuthO } from '../../hooks/useAuth';
import { landingRoutes, generalRoutes, paymentRoutes } from '../../common/routes/general';
import { createSubscription, } from '../../common/network/payment';
import { DEFAULT_PLAN } from './components/pro-checkout/content';
import AuthGate from './components/pro-checkout/auth-gate';
import SetupScreen from './components/pro-checkout/setup-screen';
import SuccessStep from './components/pro-checkout/success-step';
const Content = () => {
    var _a;
    const { auth, setContext } = useAuthO();
    // TODO: useReducer?
    const [state, mutators] = useStateWithMutators(!auth.isAuthenticated
        ? {
            'step': 'auth',
            'data': {
                'href': `${generalRoutes.signUp.getURL()}?next=${encodeURIComponent((_a = paymentRoutes === null || paymentRoutes === void 0 ? void 0 : paymentRoutes.proCheckout.getURL()) !== null && _a !== void 0 ? _a : landingRoutes.root.getURL())}`,
            },
        }
        : {
            'step': 'plan',
            'data': {
                'plan': DEFAULT_PLAN(),
                'error': null,
            },
        });
    switch (state.step) {
        case 'auth': return _jsxs(_Fragment, { children: [_jsx(AuthGate, { loginHref: state.data.href }), ","] });
        case 'plan': {
            const setSelectedPlan = (x) => mutators._({
                'step': state.step,
                'data': Object.assign(Object.assign({}, state.data), { 'plan': x })
            });
            const setError = (x) => mutators._({
                'step': state.step,
                'data': Object.assign(Object.assign({}, state.data), { 'error': x })
            });
            const handleSubmit = (plan, method) => __awaiter(void 0, void 0, void 0, function* () {
                setError(null);
                const [success, data] = yield createSubscription(plan, method);
                if (success) {
                    window.scrollTo(0, 0);
                    setContext(data.context);
                    mutators._({
                        'step': 'success',
                        'data': Object.assign(Object.assign({}, state.data), { 'entitlement': data.entitlement, 'subscription': data.subscription })
                    });
                }
                else {
                    setError("We couldn't complete your subscription. Please try again.");
                }
            });
            return _jsx(_Fragment, { children: _jsx(SetupScreen, { plan: state.data.plan, onPlanChange: setSelectedPlan, onSubmit: handleSubmit, error: state.data.error }) });
        }
        case 'success': return _jsx(_Fragment, { children: _jsx(SuccessStep, { entitlement: state.data.entitlement, subscription: state.data.subscription }) });
    }
};
const ProCheckout = () => {
    return _jsx(_Fragment, { children: _jsx("section", { className: "py-5", children: _jsx("div", { className: "container", style: { 'maxWidth': 640 }, children: _jsx(Content, {}) }) }) });
};
export default ProCheckout;
